import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { ImageModalComponent } from './image-popup';

@NgModule({
  imports: [CommonModule, FormsModule],
  declarations: [ImageModalComponent],
  exports: [ImageModalComponent]
})
export class LightBoxModule {
}



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/libs/mdbootstrap/typescripts/pro/lightbox/light-box.module.ts